/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ICustomerOrderRequest } from "../types/customers";
import api from "./api";

const handleCatch = (error: any, message?: string) => {
  if (error.code === "DATABASE_ERROR" && error?.details?.length > 0) {
    error.message = error?.details[0] ?? error?.message ?? message;
  }

  throw error;
};

export const getIncomingPayments = async (
  uid_cliente: string,
  page: number,
  orderTable?: {
    uid_cliente?: "ASC" | "DESC";
    tipo_pagamento?: "ASC" | "DESC";
    date_fina?: "ASC" | "DESC";
    tipo?: "ASC" | "DESC";
    numero_documento?: "ASC" | "DESC";
    date_initial?: "ASC" | "DESC";
    status?: "ASC" | "DESC";
    codigo_estabelecimento?: "ASC" | "DESC";
    descricao?: "ASC" | "DESC";
    conta_financeira?: "ASC" | "DESC";
    valor_parcela?: "ASC" | "DESC";
    parcela?: "ASC" | "DESC";
    data_vencimento?: "ASC" | "DESC";
    data_pagamento?: "ASC" | "DESC";
    uid_centro_custo?: "ASC" | "DESC";
    uid_plano_contas?: "ASC" | "DESC";
  },
) => {
  try {
    const res = await api.get(`/customer/getIncomingPayments`, {
      params: { uid_cliente, orderTable, page },
    });

    return res.data?.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const getCustomersRequests = async (
  uid_cliente: string,
  page: number,
  orderTable?: ICustomerOrderRequest,
) => {
  try {
    const res = await api.get(`/customer/getCustomersRequests`, {
      params: { uid_cliente, orderTable, page },
    });

    return res.data?.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const deleteClient = async (uid_cliente: string) => {
  try {
    const res = await api.post(`/customer/deleteClient`, { uid_cliente });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const loadAllClients = async (
  search?: string,
  page?: number,
  orderTable?: {
    nomeEx?: "DESC" | "ASC";
    estadoEx?: "DESC" | "ASC";
    municipioEx?: "DESC" | "ASC";
    telefoneEx?: "DESC" | "ASC";
  },
) => {
  try {
    const res = await api.get(`/customer/loadAllClients/${page}`, {
      params: { search, orderTable },
    });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const loadClientNames = async (search?: string) => {
  try {
    const res = await api.get(`/monthlyCustomer/loadClientNames`, {
      params: { search },
    });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const registerOrEditClient = async (clientData: {
  uid_cliente?: string;
  nome_fantasia: string;
  cpf_cnpj?: string;
  inscricao_estadual?: string;
  endereco?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cep?: string;
  id_municipio?: number | null;
  id_estado?: string | null;
  telefone?: string;
  whatsapp?: string;
  email?: string;
  nascimento?: string;
  is_mensalista?: boolean;
  saldo_atual?: number;
  limite_credito?: number;
  tipo_pessoa?: "fisica" | "juridica";
}) => {
  try {
    const res = await api.post("/customer/registerOrEditClient", clientData);

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const loadMensalistas = async (search?: string) => {
  try {
    const res = await api.get(`/customer/loadMensalistas`, {
      params: { search },
    });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const checkCreditLimit = async (
  uid_cliente: string,
  valor_venda: number,
) => {
  try {
    const res = await api.post(`/customer/checkCreditLimit/${uid_cliente}`, {
      valor_venda,
    });

    return res.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};

export const getCustomer = async (uid_cliente: string) => {
  try {
    const res = await api.get(`/customer/getCustomer`, {
      params: { uid_cliente },
    });

    return res.data?.data;
  } catch (error: any) {
    throw handleCatch(error);
  }
};
